<template>
  <header 
    id="app-header"
    class="navbar is-primary"
  >
    <div
      class="level container"
    >
      <div class="level-left">
        <div class="level-item navbar-brand is-marginless">
          <div class="navbar-item is-fullwidth">
            <a
              v-bind="appLogoLink"
            >
              <img
                v-bind="appLogoImage"
              >
            </a>
            <span
              class="navbar-burger burger"
              data-target="navMenu"
              aria-label="menu"
              :aria-hidden="!showOnBurgerClicked"
              @click="showOnBurgerClicked = !showOnBurgerClicked"
            >
              <span />
              <span />
              <span />
            </span>
          </div>
        </div>
        <span class="level-item vertical-separator is-hidden-mobile" />
        <div class="level-item navbar-item">
          <div class="page-title">
            <a :href="appLink">
              <h1 class="is-size-3 is-size-5-mobile">
                {{ appTitle }}
              </h1>
              <h2
                v-if="appSubtitle"
                class="is-size-5"
              >{{ appSubtitle }}
              </h2>
            </a>
          </div>
        </div>
        <div class="control-container">
          <div class="control has-icons-left">
            <div class="select">
              <select
                aria-label="language"
                @change="onChange($event)"
              >
                <option
                  v-for="(lang, i) in languages"
                  :key="`languages${i}`"
                  :value="lang.language"
                  :selected="lang.language === selectedLang"
                >
                  {{ lang.title }}
                </option>
              </select>
            </div>
            <span class="icon is-left">
              <i class="fas fa-globe fa-lg" />
            </span>
          </div>
        </div>
      </div>
      <div
        class="level-right"
        :class="{ 'is-hidden-mobile': showOnBurgerClicked }"
      >
        <div class="level-item">
          <slot />
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapMultiRowFields } from 'vuex-map-fields';

export default {
  name: 'AppHeaderInmate',
  props: {
    appLogoLink: {
      type: Object,
      default: () => ({
        href: "https://www.phila.gov",
        target: "_blank",
      }),
    },
    appLogoImage: {
      type: Object,
      default: () => ({
        src: "https://standards.phila.gov/img/logo/city-of-philadelphia-yellow-white.png",
        alt: "City of Philadelphia logo",
        width: 190,
      }),
    },
    appTitle: {
      type: String,
      default: "",
    },
    appSubtitle: {
      type: String,
      default: "",
    },
    appLink: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      showOnBurgerClicked: true,
    };
  },
  computed : {
    ...mapMultiRowFields([ 'languages' ]),
    selectedLang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    onChange(event) {
      this.$i18n.locale = event.target.value;
      localStorage.setItem('lang', event.target.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.page-title>a>h1, .page-title>a>h2 {
    color: #fff;
 }

#app-header {
  background-color: $ben-franklin-blue-dark;
}


@media screen and (max-width: $tablet) {
  header {
    .level {
      .level-left {
          display: flex;
          align-items: center;
        }
        .level-item:not(:last-child) {
          margin-bottom: 0;
        }
    }
  }

  .control div.select {
    select {
      color: transparent;
      padding: 0;
      // display: none !important;
      border-color: transparent;
    }
  }

  .control-container .control .icon {
    margin-right: 0 !important;
    left: unset !important;
    right: 10px;
  }

  .control .select:not(.is-multiple):not(.is-loading)::after  {
    border-color: transparent !important;
  }

}
  .select {
    padding-right: 5px;
  }

  .control-container {
    display: inline-flex;
    position: absolute;
    right: 0;
    top: 12px;
  }

  .select select, .fa-globe {
    background-color: transparent;
    opacity: 1.0;
    border-color:#fff;
    color: #fff;
    option {
      color: #363636;
      width: 10px;
    }
  }

  .select:not(.is-multiple):not(.is-loading)::after  {
    border-color: #fff !important;
  }
  .navbar {
    .navbar-burger {
      height: auto;

      span {
        height: 3px;
        width: 30px;
        left: calc(50% - 15px);

        &:nth-child(1) {
          top: calc(50% - 10px);
        }

        &:nth-child(3) {
          top: calc(50% + 8px);
        }
      }
    }

    .page-title {
      h1,
      h2 {
        line-height: 110%;
      }
    }

    .vertical-separator {
      width: 1px;
      height: 45px;
      background-color: #fff;
      margin-left: rem-calc(15px);
    }
    border-bottom: 5px solid $electric-blue;
  }
</style>
